export default {
  // Nav
  nav_home: 'Startseite',
  nav_features_amenities: 'Ausstattung & Annehmlichkeiten',
  nav_gallery: 'Galerie',
  nav_location: 'Lage',
  nav_rules: 'Regeln',
  nav_book_now: 'Jetzt Buchen',
  nav_language: 'Sprache',

  // Hero — Home
  hero_home_subtitle: 'Lanzarote · Kanarische Inseln',
  hero_home_title: 'Villas Yaiza',
  hero_home_tagline: 'Ein Unvergessliches Erlebnis',
  hero_home_villas: '3 Exklusive Villen',
  hero_home_guests: 'Bis zu 4 Gäste',
  hero_home_location: 'Yaiza & El Golfo',
  hero_home_authentic: 'Authentisches Lanzarote',
  hero_home_description: 'Entdecken Sie unsere Sammlung exklusiver Ferienhäuser, von modernen Luxusvillen mit privatem Pool bis hin zu traditionellen kanarischen Häusern mit atemberaubender Lagunenaussicht.',
  hero_home_explore: 'Unsere Villen Entdecken',
  hero_home_check: 'Verfügbarkeit Prüfen',
  hero_home_scroll: 'Scrollen',

  // Hero — Villas (shared keys)
  hero_from: 'Ab',
  hero_night: '/ Nacht',
  hero_check_availability: 'Verfügbarkeit Prüfen',
  hero_book_now: 'Jetzt Buchen',
  hero_scroll: 'Scrollen',

  // Search Bar
  search_check_in: 'Anreise',
  search_check_out: 'Abreise',
  search_guests: 'Gäste',
  search_guest_singular: 'Gast',
  search_guest_plural: 'Gäste',
  search_search: 'Verfügbarkeit Suchen',
  search_free_cancel: 'KOSTENLOSE Stornierung',
  search_urgency: 'Fast ausgebucht. Wir empfehlen eine baldige Buchung.',
  search_error_dates: 'Bitte wählen Sie Ihre An- und Abreisedaten.',
  search_error_order: 'Das Abreisedatum muss nach dem Anreisedatum liegen.',
  search_error_generic: 'Die Verfügbarkeit konnte nicht geprüft werden. Bitte erneut versuchen.',
  search_checking: 'Wird geprüft...',
  search_available_single: 'Für Ihre Daten verfügbar!',
  search_not_available_single: 'Für diese Daten nicht verfügbar. Versuchen Sie andere Daten.',
  search_book_now: 'Jetzt buchen',
  villas_available: 'Verfügbar',
  villas_not_available: 'Für Ihre Daten nicht verfügbar',
  villas_no_results: 'Für die gewählten Daten ist keine Villa verfügbar.',
  villas_available_for_dates: 'Villen verfügbar für Ihre Daten',

  // Why Choose
  why_title: 'Warum Villas Yaiza wählen?',
  why_subtitle: 'Ihr privater Rückzugsort im Herzen von Lanzarote',
  why_p1: 'Villas Yaiza ist eine Sammlung exklusiver Ferienhäuser, jedes völlig privat mit ruhiger Umgebung — keine gemeinsamen Bereiche.',
  why_p2: 'Im charmanten Dorf Yaiza gelegen, sind Sie nur Minuten vom Nationalpark Timanfaya, Playa Blanca, El Golfo und Los Hervideros entfernt.',
  why_p3: 'Unser lokales Team gibt Ihnen gerne Insidertipps — von versteckten Stränden bis zu den besten Restaurants der Insel.',
  why_contact: 'Sprechen Sie mit unserem Team:',
  why_phone_label: 'Telefon:',

  // Amenities / Everything you need
  amenities_subtitle: 'Warum uns wählen',
  amenities_title: 'Alles, was Sie brauchen',
  feat_private_pool: 'Privater Pool',
  feat_heated_pool: 'Beheizter Pool',
  feat_sea_views: 'Meerblick',
  feat_mountain_views: 'Bergblick',
  feat_wifi: 'Schnelles WiFi',
  feat_parking: 'Kostenloser Parkplatz',
  feat_kitchen: 'Voll Ausgestattete Küche',
  feat_bbq: 'Grill',
  feat_self_checkin: 'Selbst Check-in',
  feat_workspace: 'Arbeitsbereich',
  feat_family: 'Familienfreundlich',
  feat_garden_terrace: 'Garten & Terrasse',
  feat_traditional: 'Traditionelle Kanarische Architektur',
  feat_green_lagoon: 'Meer- & Grüne-Lagunen-Blick',
  feat_private_garden: 'Privater Garten',

  // Features section
  features_subtitle: 'Was dieser Ort bietet',
  features_title: 'Ausstattung & Annehmlichkeiten',
  features_title_home: 'Ausstattung',
  features_exterior: 'Außenbereich',
  features_interior: 'Innenbereich',
  features_kitchen: 'Küche',
  feat_outdoor_shower: 'Außendusche',
  feat_garden: 'Garten',
  feat_covered_terrace: 'Überdachte Terrasse',
  feat_smart_tv: 'Smart TV',
  feat_washing: 'Waschmaschine',
  feat_dryer: 'Trockner',
  feat_dishwasher: 'Geschirrspüler',
  feat_heating: 'Heizung',
  feat_fully_equipped: 'Voll Ausgestattet',
  feat_coffee: 'Kaffeemaschine',
  feat_kettle: 'Wasserkocher',
  feat_fridge: 'Kühlschrank',
  feat_oven: 'Ofen',
  feat_microwave: 'Mikrowelle',
  feat_kitchenware: 'Küchenutensilien',
  feat_green_lagoon_views: 'Grüne-Lagunen-Blick',
  feat_ocean_views: 'Ozeanblick',
  feat_outdoor_dining: 'Essbereich im Freien',

  // Our Villas
  villas_subtitle: 'Unsere Kollektion',
  villas_title: 'Unsere Villen',
  villas_description: 'Entdecken Sie unsere handverlesenen Häuser auf Lanzarote. Von modernen Luxusvillen mit privatem Pool bis hin zu authentischen traditionellen kanarischen Häusern bietet jede Immobilie ein einzigartiges Inselerlebnis.',
  villas_from: 'Ab',
  villas_night: '/Nacht',
  villas_guests: 'Gäste',
  villas_bedrooms: 'Schlafzimmer',
  villas_bathrooms: 'Badezimmer',
  villa_buenlugar_tagline: 'Privater Beheizter Pool',
  villa_villaflor_tagline: 'Privater Beheizter Pool',
  villa_golfo_tagline: 'Traditionelles Kanarisches Haus',

  // Layout / Room Distribution
  layout_subtitle: 'Wo Sie schlafen werden',
  layout_title: 'Zimmeraufteilung',
  room_bedroom1: 'Schlafzimmer 1',
  room_bedroom2: 'Schlafzimmer 2',
  room_bathrooms: 'Badezimmer',
  room_bathroom: 'Badezimmer',
  bed_double: '1 Doppelbett',
  bed_twin: '2 Einzelbetten',
  bed_queen: '1 Queen-Size-Bett',
  bed_bunk: 'Etagenbetten',
  bath_2full: '2 Vollbäder',
  bath_1full: '1 Vollbad',

  // Map / Location
  map_subtitle: 'Wo Sie sein werden',
  map_nearby: 'Orte in der Nähe',

  // Rules
  rules_subtitle: 'Hausregeln',
  rules_title: 'Wissenswertes',
  rule_no_smoking: 'Rauchen verboten',
  rule_no_parties: 'Keine Partys',
  rule_pets_allowed: 'Haustiere erlaubt',
  rule_private_entrance: 'Privater Eingang',
  rule_calm: 'Ruhige Gegend',
  rule_family: 'Familienfreundlich',
  license_number: 'Lizenznummer',

  // CTA
  cta_buenlugar_title: 'Fliehen Sie in die Ruhe von Lanzarote und genießen Sie Ihren privaten beheizten Pool mit unvergesslichem Meer- und Bergblick.',
  cta_buenlugar_subtitle: 'Ihr Luxus-Rückzugsort erwartet Sie in Yaiza. Buchen Sie jetzt und schaffen Sie Erinnerungen, die ein Leben lang halten.',
  cta_villaflor_title: 'Fliehen Sie in die Ruhe von Lanzarote und genießen Sie Ihren privaten beheizten Pool mit unvergesslichem Meer- und Bergblick.',
  cta_villaflor_subtitle: 'Ihr Luxus-Rückzugsort erwartet Sie in Yaiza. Buchen Sie jetzt und schaffen Sie Erinnerungen, die ein Leben lang halten.',
  cta_golfo_title: 'Fliehen Sie in die wilde Schönheit von El Golfo und erleben Sie authentisches kanarisches Leben mit unvergesslichem Blick auf die Grüne Lagune und den Ozean.',
  cta_golfo_subtitle: 'Ihr traditioneller kanarischer Rückzugsort erwartet Sie. Buchen Sie jetzt und entdecken Sie das echte Lanzarote.',
  cta_home_title: 'Fliehen Sie in die Ruhe von Lanzarote und genießen Sie Ihren privaten beheizten Pool mit unvergesslichem Meer- und Bergblick.',
  cta_home_subtitle: 'Ihr Luxus-Rückzugsort erwartet Sie in Yaiza. Buchen Sie jetzt und schaffen Sie Erinnerungen, die ein Leben lang halten.',
  cta_reserve: 'Ihren Aufenthalt Reservieren',

  // Descriptions
  desc_about: 'Über die Villa',
  desc_about_golfo: 'Über das Haus',
  desc_title: 'Ihr privater Rückzugsort auf Lanzarote',
  desc_title_golfo: 'Authentischer kanarischer Charme am Atlantik',
  desc_buenlugar_p1: 'Villa Buenlugar bietet eine entspannende Erfahrung in Yaiza, Lanzarote, mit Platz für bis zu 4 Gäste in vollkommenem Komfort und Privatsphäre.',
  desc_buenlugar_p2: 'Die Villa verfügt über zwei wunderschön eingerichtete Schlafzimmer, zwei Vollbäder mit hochwertigen Armaturen, und eine voll ausgestattete Küche mit italienischer Kaffeemaschine, Wasserkocher, Geschirrspüler und allem, was Sie für unvergessliche Mahlzeiten brauchen.',
  desc_buenlugar_p3: 'Bleiben Sie mit Highspeed-WiFi verbunden, perfekt für Videoanrufe, genießen Sie den dedizierten Arbeitsbereich, entspannen Sie sich mit dem Smart TV, und nutzen Sie die Heizung, Ventilatoren, Waschmaschine, Trockner, Babybett und Hochstuhl — alles durchdacht für Ihren Komfort.',
  desc_buenlugar_p4: 'Die Immobilie ist vollständig barrierefrei und bietet Selbst Check-in für eine nahtlose Ankunft.',
  desc_villaflor_p1: 'Casa De la Villaflor bietet eine entspannende Erfahrung in Yaiza, Lanzarote, mit Platz für bis zu 4 Gäste in vollkommenem Komfort und Privatsphäre.',
  desc_villaflor_p2: 'Die Villa verfügt über zwei wunderschön eingerichtete Schlafzimmer, zwei Vollbäder mit hochwertigen Armaturen, und eine voll ausgestattete Küche mit italienischer Kaffeemaschine, Wasserkocher, Geschirrspüler und allem, was Sie für unvergessliche Mahlzeiten brauchen.',
  desc_villaflor_p3: 'Bleiben Sie mit Highspeed-WiFi verbunden, perfekt für Videoanrufe, genießen Sie den dedizierten Arbeitsbereich, entspannen Sie sich mit dem Smart TV, und nutzen Sie die Heizung, Ventilatoren, Waschmaschine, Trockner, Babybett und Hochstuhl — alles durchdacht für Ihren Komfort.',
  desc_villaflor_p4: 'Die Immobilie ist vollständig barrierefrei und bietet Selbst Check-in für eine nahtlose Ankunft.',
  desc_golfo_p1: 'Casa de El Golfo ist ein liebevoll restauriertes traditionelles kanarisches Haus im Herzen von El Golfo, Lanzarote, das ein authentisches Inselerlebnis für bis zu 4 Gäste bietet.',
  desc_golfo_p2: 'Das Haus verfügt über zwei gemütliche Schlafzimmer mit Holzbalkendecken, ein Vollbad mit traditionellen Steinelementen, und eine voll ausgestattete Küche mit italienischer Kaffeemaschine, Wasserkocher und allem, was Sie brauchen, um lokale Mahlzeiten mit frischen Inselzutaten zuzubereiten.',
  desc_golfo_p3: 'Bleiben Sie mit Highspeed-WiFi verbunden, genießen Sie den dedizierten Arbeitsbereich, entspannen Sie sich mit dem Smart TV, und nutzen Sie die Waschmaschine, Heizung, Ventilatoren, Babybett und Hochstuhl — alles durchdacht für Ihren Komfort.',
  desc_golfo_p4: 'Die Immobilie bietet einen privaten Garten mit Grillbereich und Essbereich im Freien, plus atemberaubende Aussichten auf die ikonische Charco Verde (Grüne Lagune) und den Atlantischen Ozean. Die Immobilie ist vollständig barrierefrei und bietet Selbst Check-in für eine nahtlose Ankunft.',
  license: 'Lizenz',

  // Gallery
  gallery_subtitle: 'Fotogalerie',
  gallery_title: 'Die Villa Entdecken',
  gallery_title_golfo: 'Das Haus Entdecken',

  // Footer
  footer_brand: 'Villas Yaiza',
  footer_address: 'Yaiza · Lanzarote\nKanarische Inseln, Spanien',
  footer_quick_links: 'Schnelllinks',
  footer_info: 'Informationen',
  footer_contact: 'Kontaktieren Sie Uns',
  footer_availability: 'Verfügbarkeit',
  footer_amenities: 'Annehmlichkeiten',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_terms: 'Allgemeine Geschäftsbedingungen',
  footer_license: 'Lizenz: E-35-3-0000345',
  footer_name_placeholder: 'Ihr Name',
  footer_email_placeholder: 'Ihre Email',
  footer_message_placeholder: 'Ihre Nachricht',
  footer_send: 'Nachricht Senden',
  footer_sending: 'Wird gesendet...',
  footer_success: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.',
  footer_error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  footer_rights: 'Alle Rechte vorbehalten.',

  // Hero specifics
  hero_buenlugar_location: 'Yaiza · Lanzarote · Kanarische Inseln',
  hero_buenlugar_tagline: 'Privater Beheizter Pool · Meer- & Bergblick',
  hero_buenlugar_guests: '4 Gäste',
  hero_buenlugar_beds: '2 Schlafzimmer',
  hero_buenlugar_baths: '2 Badezimmer',
  hero_buenlugar_size: '120 m² (1,292 ft²)',

  hero_villaflor_location: 'Yaiza · Lanzarote · Kanarische Inseln',
  hero_villaflor_tagline: 'Luxusvilla in Yaiza · Lanzarote',
  hero_villaflor_guests: '4 Gäste',
  hero_villaflor_beds: '2 Schlafzimmer',
  hero_villaflor_baths: '2 Badezimmer',
  hero_villaflor_size: '120 m² (1,292 ft²)',

  hero_golfo_location: 'El Golfo · Lanzarote · Kanarische Inseln',
  hero_golfo_tagline: 'Authentisches Kanarisches Haus · El Golfo · Lanzarote',
  hero_golfo_guests: '4 Gäste',
  hero_golfo_beds: '2 Schlafzimmer',
  hero_golfo_baths: '1 Badezimmer',
  hero_golfo_size: '90 m² (969 ft²)',

  // Booking Calendar
  booking_subtitle: 'Buchen Sie Ihren Aufenthalt',
  booking_title: 'Villa Buchen',
  booking_select_date_title: 'Datum wählen',
  booking_select_date_subtitle: 'Wählen Sie Ihr Anreisedatum aus den verfügbaren Optionen',
  booking_select_time_title: 'Uhrzeit wählen',
  booking_select_time_subtitle: 'Wählen Sie das passende Zeitfenster',
  booking_review_title: 'Prüfen & Anfrage senden',
  booking_review_subtitle: 'Füllen Sie Ihre Daten aus, um Ihre Buchungsanfrage zu senden',
  booking_selected_date: 'Ausgewähltes Datum',
  booking_selected_time: 'Uhrzeit',
  booking_modify_time: 'Uhrzeit ändern',
  booking_back: 'Zurück',
  booking_name_label: 'Vollständiger Name',
  booking_name_placeholder: 'Ihr Name',
  booking_phone_label: 'Telefon',
  booking_phone_placeholder: 'Ihre Telefonnummer',
  booking_notes_label: 'Anmerkungen (optional)',
  booking_notes_placeholder: 'Gibt es etwas, das wir wissen sollten?',
  booking_submit: 'Anfrage Senden',
  booking_submitting: 'Wird gesendet...',
  booking_success_title: 'Anfrage gesendet!',
  booking_success_message: 'Vielen Dank! Ihre Anfrage wurde gesendet. Ihre Buchung ist noch nicht bestätigt — wir melden uns per E-Mail, um die Verfügbarkeit zu bestätigen.',
  booking_book_another: 'Weitere Buchung',
  booking_loading: 'Verfügbarkeit wird geladen...',
  booking_error: 'Verfügbarkeit konnte nicht geladen werden. Bitte erneut versuchen.',
  booking_retry: 'Erneut versuchen',
  booking_no_slots: 'Keine Zeitfenster für dieses Datum verfügbar.',
  booking_prev_month: 'Vorheriger Monat',
  booking_next_month: 'Nächster Monat',
  booking_required_name: 'Bitte geben Sie Ihren Namen ein.',
  booking_required_phone: 'Bitte geben Sie Ihre Telefonnummer ein.',
  booking_required_email: 'Bitte geben Sie Ihre E-Mail ein.',
  booking_invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  booking_week_sun: 'So',
  booking_week_mon: 'Mo',
  booking_week_tue: 'Di',
  booking_week_wed: 'Mi',
  booking_week_thu: 'Do',
  booking_week_fri: 'Fr',
  booking_week_sat: 'Sa',
  booking_month_jan: 'Januar',
  booking_month_feb: 'Februar',
  booking_month_mar: 'März',
  booking_month_apr: 'April',
  booking_month_may: 'Mai',
  booking_month_jun: 'Juni',
  booking_month_jul: 'Juli',
  booking_month_aug: 'August',
  booking_month_sep: 'September',
  booking_month_oct: 'Oktober',
  booking_month_nov: 'November',
  booking_month_dec: 'Dezember',

  // Villa Booking (date range)
  booking_step_dates: 'Daten',
  booking_step_details: 'Details',
  booking_select_dates_title: 'Wählen Sie Ihre Daten',
  booking_select_dates_subtitle: 'Wählen Sie An- und Abreise aus den verfügbaren Daten',
  booking_pick_checkin: 'Wählen Sie Ihr Anreisedatum',
  booking_pick_checkout: 'Wählen Sie nun Ihr Abreisedatum',
  booking_check_in_label: 'Anreise',
  booking_check_out_label: 'Abreise',
  booking_night_singular: 'Nacht',
  booking_night_plural: 'Nächte',
  booking_email_label: 'Email',
  booking_email_placeholder: 'Ihre Email',
  booking_continue: 'Weiter',
  booking_clear: 'Auswahl löschen',
  booking_invalid_range: 'Der gewählte Zeitraum enthält nicht verfügbare Daten.',
  booking_legend_available: 'Verfügbar',
  booking_legend_booked: 'Belegt',
  booking_legend_selected: 'Ausgewählt',
  booking_total: 'Gesamt',
  booking_not_confirmed: 'Bitte beachten Sie: Ihre Buchung ist erst bestätigt, wenn Sie eine Bestätigungs-E-Mail von uns erhalten.',
};